import {UpdateRecordings} from "./userDialog";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import {formatDate, getISODate, parseDateInput, Temporal} from "@/shared/utils/datefunctions";

export interface UpdateUserHourlyRateDialogConfig {
	container: JQuery;
}

const enum UpdateType {
	UPDATE_ALL_CHANGEABLE = "UPDATE_ALL_CHANGEABLE",
	UPDATE_ALL_FROM_DATE = "UPDATE_ALL_FROM_DATE"
}

import Modal = BootstrapModal.Modal;

export class UpdateUserHourlyRateDialog {

	private modal: Modal;

	private resultCallback: (result: UpdateRecordings) => void;

	constructor(private config: UpdateUserHourlyRateDialogConfig) {
		this.modal = new Modal({
			title: "dialog.update.userRecordings.title",
			message: config.container,
			css: {
				header: "bg-warning"
			},
			buttons: [{
				text: "dialog.update.userRecordings.no",
				css: "btn-primary",
				action: (modal) => {
					this.resultCallback({updateRecordings: false});
					modal.close();
				}
			}, {
				text: "dialog.update.userRecordings.yes",
				css: "btn-danger",
				left: true,
				action: (modal) => {
					const dateString = this.config.container.find("#fromDate").first().val() as string;
					const selectedOption = this.config.container.find("input[name=updateType]:checked").val() as UpdateType;

					let result: UpdateRecordings = {updateRecordings: true};
					switch (selectedOption) {
						case UpdateType.UPDATE_ALL_FROM_DATE:
							result = {...result, fromDate: getISODate(parseDateInput(dateString)), onlyChangeable: false};
							break;
						case UpdateType.UPDATE_ALL_CHANGEABLE:
							result = {...result, onlyChangeable: true};
							break;
					}
					this.resultCallback(result);
					modal.close();
				}
			}]
		});
	}

	public open(resultCallback: (result: UpdateRecordings) => void) {
		this.reset();
		this.resultCallback = resultCallback;
		this.modal.show();
	}

	private reset() {
		// initialize with current date
		this.config.container.find("#fromDate").first().val(formatDate(Temporal.Now.plainDateISO()));
		// set default option
		this.config.container.find("#updateAllFromDate").prop("checked", true);
	}

	public close() {
		this.modal.close();
	}
}
